/* esm.sh - @smithy/core@3.24.3/serde */
import "/node/buffer.mjs";
export * from "/*@smithy/core@3.24.3/esnext/serde.mjs";
